<template>
    <show-base-template v-on:edit='openEdit()' :item='item' :errors='errors' :allowedit='true' :title='title'>
        <template v-slot:body>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.name')}}: </div><div class="col-18"> {{item.name}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.icon')}}: </div><div class="col-18"><i :class='"pr-1 fa fa-2x fa-" + item.icon'></i></div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">Preview</div><div class="col-18">
                    <div class='search-lozenge-thin badge badge-primary badge-pill' :style="{'background-color': item.colour}">
                        <i v-if='item.icon' :class='"pr-1 fa fa-lg fa-" + item.icon'></i> {{ item.name }}
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class='col-18'>
                    {{ $t('translations.tag_uses')}}:
                </div>
                <div class='col-18'>
                    <ul>
                        <template v-for='tags_tag_use in item.tags_tag_use'>
                            <li :key='tags_tag_use.tag_use_id'>
                                {{tBrandKey(tags_tag_use.tag_use.name)}}
                            </li>
                        </template>
                    </ul>
                </div>            
            </div>


        </template>
    </show-base-template>
</template>

<script>
	export default {
        extends: app.base.showBase,
        props: [
        ],

        data() {
            return {
                event: "tag",
                model: "tag",
                title: "Tags",
                path: 'tags',
                route: '/api/v1/tags',
                allowedit: true,
                title: 'Tag',
            };
        },
        methods: {
            
        }
    };
</script>
